import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listJobNotes, createJobNote, deleteJobNote } from '../api';
import type { CreateJobNoteInput, JobNotesQuery } from '@maker-toolchest/shared';

export function useJobNotes(jobId: string, query?: JobNotesQuery) {
  return useQuery({
    queryKey: ['jobNotes', jobId, query],
    queryFn: () => listJobNotes(jobId, query),
    enabled: !!jobId, // Only fetch when we have a valid jobId
  });
}

export function useCreateJobNote(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateJobNoteInput) => createJobNote(jobId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobNotes', jobId] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
    },
  });
}

export function useDeleteJobNote(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (noteId: string) => deleteJobNote(jobId, noteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobNotes', jobId] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
    },
  });
}
